export const environment = {
  clientID: '4',
};
